// eslint-disable-next-line import/no-extraneous-dependencies
import { Context, Plugin } from '@nuxt/types';
import { createGrowthbookInstance } from '~/services/GrowthBookService';
import { getGBSessionId, waitForSessionId } from '~/services/CookieService';

declare global {
  interface Window {
    __growthbookInitialized: boolean;
  }
}

const growthbookPlugin: Plugin = async (context: Context): Promise<void> => {
  if (typeof window !== 'undefined' && window.__growthbookInitialized) {
    console.log('Growthbook already initialized, skipping plugin execution.');
    return;
  }

  const sessionId = await waitForSessionId(getGBSessionId, 10, 500) ?? '';
  await createGrowthbookInstance(context.store, sessionId);
  window.__growthbookInitialized = true;
};

export default growthbookPlugin;
